<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
                <h2>Fale connosco</h2>
                <h3>Sem compromisso</h3>
            </div>
            <fieldset class="tw-pt-3 tw-px-5 lg:tw-pt-0 lg:tw-px-10">
                <validation-provider class="tw-w-full tw-w-block" name="course" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-selected-course" :class="classes">
                        <select
                            class="input-group-select form-select"
                            @change="redirectToCourse"
                            v-model="course">
                            <option disabled value="">Selecione um curso</option>
                            <option v-for="course in $store.state.courseList" :key="course.code" :value="slugifyCourse(course.humanFriendlyName)">{{ course.humanFriendlyName }}</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            id="input-fullName"
                            placeholder=" "
                            v-model="fullName"
                        >
                        <label>
                            Nome e Apelido
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            id="input-phone"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'#########'"
                        >
                        <label>
                            Telefone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="district" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-district" :class="classes">
                        <select
                            class="input-group-select form-select"
                            v-model="district">
                                <option disabled value="">Distrito</option>
                                <option value="Grande Lisboa">Grande Lisboa</option>
                                <option value="Grande Porto">Grande Porto</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span>Autorizo a eFuturo a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                        id="submit"
                        :disabled="formLoading"
                    >
                        Solicitar Informação
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            courseList: [],
            courseInfo: [],
            course: '',
            fullName: '',
            phone: '',
            email: '',
            district: '',

            formLoading: false,
            usedClasses: ['.has-error']
        };
    },
    methods: {
        slugifyCourse(course) {
            return slugify(course).toLowerCase();
        },
        redirectToCourse() {
            this.$router.push({ path: `/${this.course}`, query: this.$route.query  });
            this.getCourseInfo();
        },
        getCourseInfo() {
            axios
                .get(`https://kw-lp-info.s3-eu-west-1.amazonaws.com/eFuturo/courses/${this.$route.params.course}/info.json`)
                .then((response) => {
                    this.$store.state.courseInfo = response.data;
                    this.course = this.slugifyCourse(this.$store.state.courseInfo.humanFriendlyName);
                })
                .catch(() => {
                    this.$router.push('/');
                });
        },
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                ip: this.$store.state.ip,
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                course: this.course,
                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                district: this.district,

                mclic: process.env.VUE_APP_MCLIC,
                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'inválido ou já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
    mounted() {
        this.getCourseInfo();
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
form {
	padding: 32px 0;
	background-color: #fff;
	@screen lg {
		margin-left: auto;
		padding: 45px 0 39px 0;
		max-width: 380px;
	}
	h2 {
		color: $main_color;
		font-weight: 700;
		font-size: 26px;
		line-height: 21px;
		@screen lg {
			font-size: 36px;
		}
	}
	h3 {
		color: $main_color;
		font-size: 16px;
		@screen lg {
			margin-bottom: 11px;
			font-size: 20px;
		}
	}
}

</style>
